import React from 'react'

function Topbuttons({setQuery}) {
    /*array of objects*/
    const cities=[
        {
            id:1,
            Name:"Delhi"
        },
        {
            id:2,
            Name:"Mumbai"
        },
        {
            id:3,
            Name:"Kanpur"
        },
        {
            id:4,
            Name:"Chennai"
        },
        {
            id:5,
            Name:"Kolkata"
        },
    ]
  return <div className='flex items-center justify-around my-6'>
     {/* {cities.map((city)=>(
        <button  onClick={()=>setQuery({q:city.Name})} key={city.id} className='text-white text-lg font-medium'>{city.Name}</button>
     ))}  */}
     {cities.map((city)=>(
        <button key={city.id} onClick={()=>setQuery({q:city.Name})} className=' text-white font-medium text-lg'>{city.Name}</button>
    ) )}
  </div>
}

export default Topbuttons